import mutationTypes from '../mutation-types.js'
import userService from '../../services/userService.js'

const state = {
  isAuthenticated: false,
  currentUser: {
    roles: []
  },
  allUsers: []
}

const getters = {
  allUsers: state => {
    return state.allUsers
  },
  allowedRoles: state => {
    if (state.currentUser && state.currentUser.roles) {
      return state.currentUser.roles.map((x) => {
        return x.name
      })
    } else {
      return []
    }
  },
  allowedFeatures: state => {
    if (state.currentUser && state.currentUser.features) {
      return state.currentUser.features
    } else {
      return []
    }
  },
  allowedFeatureCodes: state => {
    if (state.currentUser && state.currentUser.features) {
      return state.currentUser.features.map((x) => {
        return x.code
      })
    } else {
      return []
    }
  },
  roleCount: (state, getters) => {
    return getters.allowedRoles ? getters.allowedRoles.length : 0
  },
  isInRole: (state, getters) => (requiredRole) => {
    return getters.allowedRoles.includes(requiredRole)
  },
  hasFeatureAccess: (state, getters) => (requiredFeatureCode, deep = true) => {
    var hasAccess = getters.allowedFeatureCodes.includes(requiredFeatureCode)
    if (!hasAccess && deep === true) {
      var parts = requiredFeatureCode.split('.')
      var partToCheck = ''
      for (var i = 1; i < parts.length; i++) {
        partToCheck += parts[i - 1] + '.'
        hasAccess = getters.allowedFeatureCodes.includes(partToCheck + '*')
        if (hasAccess === true) {
          break
        }
      }
    }
    return hasAccess
  },
  currentUser: state => {
    return state.currentUser
  }
}

const mutations = {
  [mutationTypes.SET_CURRENT_USER] (state, newUser) {
    state.isAuthenticated = newUser.firstName !== undefined
    state.currentUser = newUser
  },
  [mutationTypes.SET_USERS] (state, users) {
    state.allUsers = users
  },
  [mutationTypes.SYNC_USER] (state, entity) {
    var applicable = state.allUsers.find((x) => x.id === entity.id)
    if (applicable) {
      applicable = entity
    } else {
      state.allUsers.push(entity)
    }
  }
}

const actions = {
  setCurrentUser ({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      commit(mutationTypes.SET_CURRENT_USER, { isValid: false })
      userService.single(id)
        .then((user) => {
          commit(mutationTypes.SET_CURRENT_USER, user.user)
          resolve(user)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  syncUser ({ commit, state }, entity) {
    commit(mutationTypes.SYNC_USER, entity)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
